module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/vle/vle.component.css
// module id = ./src/app/Pages/manage/vle/vle.component.css
// module chunks = main